import { useSyncExternalStore } from 'react'

/** Быстрая панель над элементом прячется, пока поверх открыт свой попап (выбор
 *  иконки бейджа): иначе она просвечивала из-под него. */
let suppressed = false
const listeners = new Set<() => void>()

export const setDesignToolbarSuppressed = (next: boolean): void => {
  if (suppressed === next) return
  suppressed = next
  listeners.forEach((l) => l())
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const useDesignToolbarSuppressed = (): boolean =>
  useSyncExternalStore(subscribe, () => suppressed)
